(function() {
  function initBirlikteAl(scope) {
    var roots = (scope || document).querySelectorAll('[data-scp-ba-root]');

    roots.forEach(function(root) {
      if (root.dataset.scpBaReady === 'true') return;
      root.dataset.scpBaReady = 'true';

      var checkboxes = root.querySelectorAll('[data-ba-checkbox]');
      var addButton = root.querySelector('[data-ba-add-selected]');
      if (!addButton || checkboxes.length === 0) return;

      var addLabelNode = addButton.querySelector('.scp-ba-add-text');
      var defaultLabel = addLabelNode ? addLabelNode.textContent.trim() : 'Secilenleri Sepete Ekle';
      var cartDrawer = document.querySelector('cart-drawer');

      function getSelectedItems() {
        var items = [];
        checkboxes.forEach(function(input) {
          if (!input.checked || input.disabled) return;
          var id = Number(input.value);
          if (!id) return;
          items.push({ id: id, quantity: 1 });
        });
        return items;
      }

      function syncState() {
        var selectedItems = getSelectedItems();
        addButton.disabled = selectedItems.length === 0;
        if (addLabelNode) {
          if (selectedItems.length > 0) {
            addLabelNode.textContent = defaultLabel + ' (' + selectedItems.length + ')';
          } else {
            addLabelNode.textContent = defaultLabel;
          }
        }
      }

      checkboxes.forEach(function(input) {
        input.addEventListener('change', syncState);
      });

      root.querySelectorAll('[data-ba-card]').forEach(function(card) {
        card.addEventListener('click', function(event) {
          var target = event.target;
          if (target.closest('a') || target.closest('input') || target.closest('button')) return;
          var input = card.querySelector('[data-ba-checkbox]');
          if (!input || input.disabled) return;
          input.checked = !input.checked;
          syncState();
        });
      });

      function publishCartUpdate(payload) {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, payload || { source: 'scp-birlikte-al' });
        }
      }

      function openCartDrawerIfExists() {
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        }
      }

      function setLoadingState(isLoading) {
        if (isLoading) {
          addButton.disabled = true;
          addButton.classList.add('is-loading');
          if (addLabelNode) addLabelNode.textContent = 'Ekleniyor...';
        } else {
          addButton.classList.remove('is-loading');
          syncState();
        }
      }

      addButton.addEventListener('click', function() {
        var items = getSelectedItems();
        if (items.length === 0 || addButton.disabled) return;

        var payload = { items: items };
        if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
          var sections = cartDrawer.getSectionsToRender().map(function(section) { return section.id; });
          if (sections.length) {
            payload.sections = sections;
            payload.sections_url = window.location.pathname;
          }
        }

        setLoadingState(true);

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify(payload),
          credentials: 'same-origin'
        })
          .then(function(response) {
            if (!response.ok) throw new Error('Cart add failed');
            return response.json();
          })
          .then(function(data) {
            if (cartDrawer) {
              if (cartDrawer.classList.contains('is-empty')) {
                cartDrawer.classList.remove('is-empty');
              }
              if (data.sections && typeof cartDrawer.renderContents === 'function') {
                cartDrawer.renderContents(data);
              } else {
                publishCartUpdate({ source: 'scp-birlikte-al', cartData: data });
                openCartDrawerIfExists();
              }
            } else {
              publishCartUpdate({ source: 'scp-birlikte-al', cartData: data });
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'scp-birlikte-al', response: data, optimistic: true } }));
              document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
              document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            }

            checkboxes.forEach(function(input) {
              if (!input.disabled) input.checked = false;
            });
            setLoadingState(false);
          })
          .catch(function() {
            setLoadingState(false);
          });
      });

      syncState();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initBirlikteAl(document);
    });
  } else {
    initBirlikteAl(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    initBirlikteAl(event.target);
  });
})();
